'use client'

import { useEffect, useState } from 'react'
import { Column, Grid } from '@carbon/react'
import { homeCopy, type HomeCopy } from '@/lib/home-i18n'

const locations = [
  { flag: '🇺🇸', label: 'US (West)', country: 'United States' },
  { flag: '🇺🇸', label: 'US (Central)', country: 'United States' },
  { flag: '🇺🇸', label: 'US (East)', country: 'United States' },
  { flag: '🇬🇧', label: 'United Kingdom', country: 'United Kingdom' },
  { flag: '🇪🇺', label: 'EU', country: 'European Union' },
  { flag: '🇮🇳', label: 'Asia (India)', country: 'India' },
  { flag: '🇸🇬', label: 'Asia (Singapore)', country: 'Singapore' },
  { flag: '🇯🇵', label: 'Asia (Japan)', country: 'Japan' },
  { flag: '🇦🇺', label: 'Australia (Sydney)', country: 'Australia' },
] as const

const locationsPerGroup = 3
const locationGroups = Array.from(
  { length: Math.ceil(locations.length / locationsPerGroup) },
  (_, index) => locations.slice(index * locationsPerGroup, index * locationsPerGroup + locationsPerGroup),
)

export function DatacenterLocations({ copy = homeCopy('en') }: { copy?: HomeCopy } = {}) {
  const [groupIndex, setGroupIndex] = useState(0)

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (reducedMotion.matches || locationGroups.length < 2) return

    const timer = window.setInterval(() => {
      setGroupIndex((current) => (current + 1) % locationGroups.length)
    }, 4200)

    return () => window.clearInterval(timer)
  }, [])

  return (
    <section className="section datacenter-locations" aria-labelledby="datacenter-locations-title">
      <Grid>
        <Column sm={4} md={4} lg={5}>
          <p className="section-label">{copy.infrastructure}</p>
          <h2 id="datacenter-locations-title" className="section__title">{copy.dataCenterLocations}</h2>
          <p className="section__subtitle">{copy.regionAvailability}</p>
        </Column>
        <Column sm={4} md={4} lg={{ span: 10, offset: 1 }}>
          <div className="datacenter-locations__grid" aria-label={copy.availableRegions}>
            {locationGroups[groupIndex].map(({ flag, label, country }) => (
              <div className="datacenter-locations__item" key={label}>
                <span className="datacenter-locations__flag" role="img" aria-label={country}>{flag}</span>
                <span>{label}</span>
              </div>
            ))}
          </div>
          <div className="datacenter-locations__progress" aria-hidden="true">
            {locationGroups.map((_, index) => (
              <span
                key={index}
                className={`datacenter-locations__progress-dot${index === groupIndex ? ' datacenter-locations__progress-dot--active' : ''}`}
              />
            ))}
          </div>
          <div className="datacenter-locations__brands" aria-label={copy.infrastructureTechnologies}>
            <img src="/brand/brands-ds-2.svg" alt="HPE and AMD EPYC" width="1200" height="200" loading="lazy" decoding="async" />
          </div>
        </Column>
      </Grid>
    </section>
  )
}
